<template>
  <div class="content-wrapper">
    <h2 v-if="computedPath" class="page-titles">
      Edit redemption page
    </h2>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'GroupOrderEdit',

  computed: {
    computedPath() {
      return (
        !this.$route.path.includes('add-card') &&
        !this.$route.path.includes('redemption-info')
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>
